import React from 'react';
import styles from './Style.module.css';
import { Calendar, Clock3, Tag } from 'lucide-react';
import { formatDate } from '../../Utils/Helper';
import { resolveBookingDateTime } from '../../Utils/resolveBookingDateTime';

const TimeDetail = ({ selectedDate, selectedTime, bookingID }) => {
  const resolved = resolveBookingDateTime(selectedDate, selectedTime);
  const { dayName, dayNum, monthName, yearNum } = formatDate(resolved.date || selectedDate);

  return (
    <div className={styles.timeCardContainer} role="group" aria-label="Appointment details">
      <div className={styles.timeCard}>
        <span className={styles.icon} aria-hidden="true"><Calendar /></span>
        <span className={styles.value}>{dayName}, {dayNum} {monthName} {yearNum}</span>
      </div>
      <div className={styles.timeCard}>
        <span className={styles.icon} aria-hidden="true"><Clock3 /></span>
        <span className={`${styles.value} ${styles.timeValue}`}>{resolved.displayTime}</span>
      </div>
      {bookingID != null && bookingID !== '' && (
        <div className={`${styles.timeCard} ${styles.bookingReference}`}>
          <span className={styles.icon} aria-hidden="true"><Tag /></span>
          <span className={styles.value}>ID#{bookingID}</span>
        </div>
      )}
    </div>
  );
};

export default TimeDetail;
